module.exports = __webpack_public_path__ + "static/media/image17.e18894b5.jpg";